
// export const VideoSelectAction = {
//     RELEASE: "release",
//     SELECT: "select",
//     SAVE: "save"
// } as const
// export type VideoSelectActionType = typeof VideoSelectAction[ keyof typeof VideoSelectAction ]

export type ActionObjectType = {
    type: VideoActionType,
    time?: number
}


export const WebViewVideoAction = {
    SET_VIDEO_CONTROLLER: "setVideoController",
    VIDEO_LOADED: "videoLoaded",
    START_SEEK: "startSeek",
    HEIGHT_DOUBLE_CHECK: "heightDoubleCheck",
    END_SEEK: "endSeek",
    START_DRAW: "startDraw",
    END_DRAW: "endDraw",
    VIDEO_RELEASE: "videoRelease",
    VIDEO_SELECT: "videoSelect",
    SAVE_VIDEO: "saveVideo",
    ADD_IMAGE_TO_COMMENT: "addImageToComment",
    DOWNLOAD_CANVAS_IMAGE: "downloadCanvasImage",
    DOWNLOAD_VIDEO: "downloadVideo",
} as const

export type WebViewVideoActionType = typeof WebViewVideoAction[ keyof typeof WebViewVideoAction ]

type EventType = {
    event: WebViewVideoActionType
}

export const VideoAction = {
    PLAY: "play",
    PAUSE: "pause",
    SET_USUAL_SPEED: "setUsualSpeed",
    SET_SLOW: "setSlow",
    TICK: "tick",
    SET_TIME_TO_SYNC_START_TIME: "setTimeToSyncStartTime",
    SET_TIME_TO_SYNC_START_TIME_AND_PLAY: "setTimeToSyncStartTimeAndPlay"
} as const
export type VideoActionType = typeof VideoAction[ keyof typeof VideoAction ]

export const VideoSelectAction = {
    SELECT: "select",
    RELEASE: "release",
    SAVE: "save"
} as const
export type VideoSelectActionType = typeof VideoSelectAction[ keyof typeof VideoSelectAction ]


// export const WebViewVideoAction = {
//     VIDEO_LOADED: "videoLoaded",
//     START_SEEK: "startSeek",
//     END_SEEK: "endSeek",
//     DOWNLOAD_VIDEO:"downloadVideo",
// } as const
// export type WebViewVideoActionType = typeof WebViewVideoAction[ keyof typeof WebViewVideoAction ]
